
import { Vue, Component, Prop } from "vue-property-decorator";
import textEditor from "./text-editor.vue";
import uploadFile from "./uploadFile.vue";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "comDetails",
  components: {
    textEditor,
    uploadFile
  }
})
export default class comDetails extends BaseVue {
  @Prop({ default: () => [1,1,1,1] }) border!: any; 
  
  mounted(){
  }

}
